import React from "react";

const titleStyle = {
  fontSize: "16px",
};

const Title = ({ text }) => {
  return (
    <div style={titleStyle} className="font-weight-bold">
      {text}
    </div>
  );
};

export default Title;
